export const meta = {
  "meta.tagline": "Cassino ao vivo, apostas e jogos online",
  "meta.description":
    "Cassino ao vivo, caça-níqueis, apostas esportivas e minijogos. Cadastre-se e jogue agora.",
};
